import { Card, CardDownLoadBtn } from "./CommonComponents";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../styles/slider.css";
import { StepCircle } from "./svgs";
import contents from "../utills/page_contents.json";
import { downloadGuideFile } from "../api/api";

function GuideCarousel() {
  const {guide_steps} = contents
  return (
    <>
      <Swiper
        modules={[Pagination, Navigation]}
        slidesPerView={1}
        pagination={{
          clickable: true,
          bulletElement: 'svg',
        }}
        navigation={true}
        scrollbar={{ draggable: true }}
      >
        {guide_steps.map((step, index) => (
          <SwiperSlide key={step.title}>
            <Card index={index} id={`price_card${index}`}>
              <StepCircle step={index + 1} />
              <h1>{step.title}</h1>
              <span>{step.description}</span>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      <CardDownLoadBtn onClick={downloadGuideFile}>
        Download Guide
      </CardDownLoadBtn>
    </>
  );
}

export default GuideCarousel;
